import R from "ramda";
import { APP_ROUTE_PARAM_PATTERN } from "../constants/config";

const calculatePathParams = pathPattern => {
  const { pathname } = window.location;
  return R.compose(
    paramsList => ({
      applyId: paramsList[0],
      step: paramsList[1],
      card: paramsList[2]
    }),
    R.split("/"),
    pageName => pathname.substring(pageName.length + 1, pathname.length),
    pattern => pathname.substring(0, pattern.indexOf(APP_ROUTE_PARAM_PATTERN))
  )(pathPattern);
};

const convertAppPathPattern = (pathPattern, applyId, step, card) => {
  if (!pathPattern) {
    return false;
  }

  const { search } = window.location;
  const prevParams = calculatePathParams(pathPattern);

  return R.compose(
    val => `${val}${search}`,
    R.replace(":card?", card || prevParams.card || ""),
    R.replace(":step?", step || prevParams.step || ""),
    R.replace(":applyId", applyId || prevParams.applyId || "")
  )(pathPattern);
};

export default convertAppPathPattern;
